module.exports = __webpack_public_path__ + "img/buzz-sentiment.cc3b2bf3.svg";